module.exports = __webpack_public_path__ + "static/media/Spotify-Bold.c147cc23.woff2";